import r from"react";import a from"./Breadcrumb.styles.js";const e=({separator:e="/"})=>r.createElement("li",{className:a.separator,"data-testid":"breadcrumb-separator"},e);export{e as default};
